var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnBoard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5,
    cy: 7.50006,
    r: 7.5,
    fill: "#B5F5EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.8337 7.34782L11.2759 5.95319L10.0137 5.95587L10.0056 4.92194L11.3916 4.92194C11.5634 4.92124 11.7315 4.9723 11.8739 5.06851C12.0164 5.16482 12.1266 5.30187 12.19 5.46176L12.7912 6.96482C12.897 7.22922 12.7684 7.5293 12.504 7.63506C12.2396 7.74083 11.9395 7.61222 11.8337 7.34782Z",
    fill: "#08979C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17188 8.18756C2.17188 7.90279 2.40273 7.67194 2.6875 7.67194H9.5625C9.84727 7.67194 10.0781 7.90279 10.0781 8.18756C10.0781 8.47233 9.84727 8.70319 9.5625 8.70319H2.6875C2.40273 8.70319 2.17188 8.47233 2.17188 8.18756Z",
    fill: "#08979C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.73438 9.73444C9.4496 9.73444 9.21875 9.96529 9.21875 10.2501C9.21875 10.5348 9.4496 10.7657 9.73438 10.7657C10.0191 10.7657 10.25 10.5348 10.25 10.2501C10.25 9.96529 10.0191 9.73444 9.73438 9.73444ZM8.1875 10.2501C8.1875 9.39575 8.88006 8.70319 9.73438 8.70319C10.5887 8.70319 11.2812 9.39575 11.2812 10.2501C11.2812 11.1044 10.5887 11.7969 9.73438 11.7969C8.88006 11.7969 8.1875 11.1044 8.1875 10.2501Z",
    fill: "#08979C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26562 9.73444C4.98085 9.73444 4.75 9.96529 4.75 10.2501C4.75 10.5348 4.98085 10.7657 5.26562 10.7657C5.5504 10.7657 5.78125 10.5348 5.78125 10.2501C5.78125 9.96529 5.5504 9.73444 5.26562 9.73444ZM3.71875 10.2501C3.71875 9.39575 4.41131 8.70319 5.26562 8.70319C6.11994 8.70319 6.8125 9.39575 6.8125 10.2501C6.8125 11.1044 6.11994 11.7969 5.26562 11.7969C4.41131 11.7969 3.71875 11.1044 3.71875 10.2501Z",
    fill: "#08979C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.78125 10.2501C5.78125 9.96529 6.0121 9.73444 6.29688 9.73444H8.70312C8.9879 9.73444 9.21875 9.96529 9.21875 10.2501C9.21875 10.5348 8.9879 10.7657 8.70312 10.7657H6.29688C6.0121 10.7657 5.78125 10.5348 5.78125 10.2501Z",
    fill: "#08979C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.20312 5.26569V9.73444H4.23438C4.51915 9.73444 4.75 9.96529 4.75 10.2501C4.75 10.5348 4.51915 10.7657 4.23438 10.7657H3.03125C2.80333 10.7657 2.58474 10.6751 2.42358 10.514C2.26242 10.3528 2.17188 10.1342 2.17188 9.90631V5.09381C2.17188 4.86589 2.26242 4.64731 2.42358 4.48614C2.58474 4.32498 2.80333 4.23444 3.03125 4.23444H9.5625C9.84727 4.23444 10.0781 4.46529 10.0781 4.75006V9.2317C10.0781 9.51647 9.84727 9.74733 9.5625 9.74733C9.27773 9.74733 9.04688 9.51647 9.04688 9.2317V5.26569H3.20312Z",
    fill: "#08979C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.04688 7.15631C9.04688 6.87154 9.27773 6.64069 9.5625 6.64069H12.3125C12.5973 6.64069 12.8281 6.87154 12.8281 7.15631V9.90631C12.8281 10.1342 12.7376 10.3528 12.5764 10.514C12.4153 10.6751 12.1967 10.7657 11.9688 10.7657H10.7656C10.4809 10.7657 10.25 10.5348 10.25 10.2501C10.25 9.96529 10.4809 9.73444 10.7656 9.73444H11.7969V7.67194H9.5625C9.27773 7.67194 9.04688 7.44108 9.04688 7.15631Z",
    fill: "#08979C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnBoard);
export default __webpack_public_path__ + "static/media/OnBoard.26870715.svg";
export { ForwardRef as ReactComponent };